import * as React from "react";

function SvgExtole(props, ref) {
  return (
    <svg
      id="extole_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 58.8"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".extole_svg__cls-1{fill:#e01b4c}"}</style>
      </defs>
      <path
        className="extole_svg__cls-1"
        d="M37 10a.63.63 0 00-.36-.1.76.76 0 00-.75.75V17a1.37 1.37 0 00.69 1.17L57.63 30.5v24.61a1.34 1.34 0 00.66 1.17l5.48 3.2a.73.73 0 001-.27.74.74 0 00.1-.37V27.3a1.81 1.81 0 00-.87-1.56zM42 46.77a.59.59 0 01.27.27.74.74 0 01-.27 1l-5.21 3a1.75 1.75 0 01-1.78 0l-5.45-3.18a1.79 1.79 0 01-.88-1.56V40a1.82 1.82 0 01.89-1.57l5.21-3a.8.8 0 01.38-.1.74.74 0 01.73.75v7.15z"
        transform="translate(-14.16 -9.88)"
      />
      <path
        className="extole_svg__cls-1"
        d="M43.79 47.8a1.35 1.35 0 01-.67-1.17V39l-6.55-3.83a1.36 1.36 0 01-.68-1.17v-6.4a.76.76 0 01.75-.75.79.79 0 01.37.1l12.48 7.3a1.79 1.79 0 01.88 1.55v14.56a.74.74 0 01-.1.37.73.73 0 01-1 .27z"
        transform="translate(-14.16 -9.88)"
      />
      <path
        className="extole_svg__cls-1"
        d="M34.79 18.45a.75.75 0 01.37-.09.74.74 0 01.73.75v6.4a1.34 1.34 0 01-.66 1.16l-13.81 8.07v16.91l14.47 8.46L49.71 52A1.32 1.32 0 0151 52l5.48 3.2a.73.73 0 01.27.28.76.76 0 01-.27 1L36.79 68.07a1.76 1.76 0 01-1.79 0L15.05 56.41a1.79 1.79 0 01-.88-1.56V31.54a1.81 1.81 0 01.88-1.54z"
        transform="translate(-14.16 -9.88)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgExtole);
